import React from 'react';
import PropTypes from 'prop-types';
import { MatchTimeWrapper, DateWrapper, HoursWrapper } from './styles';

const MatchTime = ({
  date, status,
}) => {
  const dateFormat = (datetime, isHour) => {
    const dateJs = new Date(date);
    const day = (`0${dateJs.getDate().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const month = (`0${Number(dateJs.getMonth().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })) + 1}`).slice(-2);
    const hours = (`0${dateJs.getHours().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    if (isHour) {
      return `${hours}:${minutes}`;
    }
    return `${day}/${month}`;
  };
  return (
    <MatchTimeWrapper>
      {status !== 'POSTPONED' ?
        <React.Fragment>
          <DateWrapper>
            {dateFormat(date, false)}
          </DateWrapper>
          <HoursWrapper>
            {dateFormat(date, true)}
          </HoursWrapper>
        </React.Fragment> :
        <HoursWrapper>
          Rinviata
        </HoursWrapper>
      }
    </MatchTimeWrapper>
  );
};

MatchTime.propTypes = {
  date: PropTypes.any,
  status: PropTypes.any,
};

export default MatchTime;



// WEBPACK FOOTER //
// ./src/components/shared/MatchTime/index.js